import { authGet } from "@api";
import { DEPLOYMENT_URL } from "@constants";
import { DeploymentRepoResponse } from "@types";

export const fetchDemoRepo = (
  deploymentId: string
): Promise<DeploymentRepoResponse> => {
  let url = `${DEPLOYMENT_URL}/${deploymentId}/demo_project`;
  return authGet<DeploymentRepoResponse>(url);
};
